import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ElementPortableText from 'src/components/ElementPortableText/ElementPortableText';

function SimpleBlock({ body }) {
  return (
    <Container as="section" className="py-5">
      <Row noGutters>
        <Col xs={12} md={{ span: 10, offset: 2 }} lg={{ span: 8, offset: 3 }}>
          <ElementPortableText content={body} />
        </Col>
      </Row>
    </Container>
  );
}

export default SimpleBlock;
